import { showNotify } from 'vant';

export function errorHandler(error: any) {
  if (error.response) {
    const msg = error.response.data.message || `error：${error.response.status}`
    showNotify({ type: 'danger', message: msg })
  } else if (error.message) {
    showNotify({ type: 'danger', message: error.message })
  } else {
    showNotify({ type: 'danger', message: 'error' })
  }
}
